import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DepthLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "square", d: "M6.61 2.32V22M3 5.674 6.578 2l3.578 3.674M10.156 18.326 6.578 22 3 18.326M14 2h7.348M14 7h5.24M14 12h7.348M14 17h5.24M14 22h7.348" })));
}
const DepthLightCustom = forwardRef(_DepthLightCustom);
export { DepthLightCustom };
